import { Link } from "react-router-dom";
import { RegrasConvenio } from "./regras-convenio";

/**
 * As regras por convenio como pagina do portal, em `/banco/convenios/regras`.
 *
 * O conteudo e' o mesmo da secao "Regras dos seus convênios" da documentacao da
 * API — la ele continua, para quem integra. Aqui ele existe porque era a unica
 * tela com tetos, exigencias, corte e repasse de cada convenio, e so' se chegava
 * nela pela documentacao.
 */
export function BancoRegrasConvenio() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <Link to="/banco/convenios" style={{ fontSize: 13 }}>← Seus convênios</Link>
      <RegrasConvenio />
    </div>
  );
}
